module.exports = __webpack_public_path__ + "static/media/company-dashboard.f32e06a0.svg";